module.exports = __webpack_public_path__ + "media/images/partner/pic_5@2x-0853b3e4b01e9d977b5d02d14208ec02.png";